// extracted by mini-css-extract-plugin
module.exports = {"label":"Label_label__2-IM8","labelWithTooltip":"Label_labelWithTooltip__3-5iV","tooltip":"Label_tooltip__3YuOR"};